import urlJoin from 'url-join'
import { useStoreConfig } from '~/store/storeConfig'
import getPublicUrl from '~/utils/routing/getPublicUrl'

export default () => {
  const { t } = useLang()
  const route = useRoute()
  const { isTarpininke, isNoriuLive, isAmeerikaEestis } = useTheme()
  const storeConfig = useStoreConfig()
  const image = useImage()

  const verifyPaysera = computed(() => {
    if (isTarpininke) {
      return 'b604c2c8332e12ea68caeb7ee950e342'
    }

    if (isNoriuLive) {
      return '57ef6ea0ac2764e9bd15bb6840239d22'
    }

    if (isAmeerikaEestis) {
      return '8d8452aff460df22bcd367dd3b1f0695'
    }

    return '504c5292e775a57f554a6c0c5fdf0434'
  })

  const heroUrl = computed(() => {
    let originalUrl = `banners/dealzone-service-hero.png`

    if (isTarpininke) {
      originalUrl = `banners/tp-meta-img.png`
    }

    if (isAmeerikaEestis) {
      originalUrl = `banners/ae-hero.png`
    }

    return image(originalUrl, {
      format: 'webp',
      quality: 75,
      height: 800,
    })
  })

  const publicUrl = getPublicUrl()

  const siteName = computed(() => storeConfig.getSite?.name ?? '')
  const siteLogo = computed(() => storeConfig.getSite?.cdn_logo ?? '')
  const metaTitle = computed(() => t('meta.title'))
  const metaUrl = computed(() => urlJoin(publicUrl, route.path, '/'))
  const metaType = ref<string>('website')
  const defaultOgImage = computed(() => {
    return typeof window !== 'undefined' ? heroUrl.value : urlJoin(publicUrl, heroUrl.value)
  })
  const metaImage = computed(() => siteLogo.value || defaultOgImage)

  return {
    siteName,
    metaTitle,
    metaUrl,
    metaType,
    metaImage,
    verifyPaysera,
  }
}
